import {
	COUNTRY_VALUE_ERROR,
	COUNTRY_VALUE_SUCCESS,
	COUNTRY_VALUE,
} from "Constant";

const initialState = {
	countriesJson: [],
	currencySymbols: [],
};

function countryReducer(state = initialState, action) {
	switch (action.type) {
		case COUNTRY_VALUE:
			return {
				...state,
				countriesJson: [],
				currencySymbols: [],
			};
		case COUNTRY_VALUE_SUCCESS:
			return {
				...state,
				countriesJson: action.payload.countries,
				currencySymbols: action.payload.currencies,
			};

		case COUNTRY_VALUE_ERROR:
			return {
				...state,
				countriesJson: [],
				currencySymbols: [],
			};

		default:
			return state;
	}
}

export default countryReducer;
